// Only these Office-owned origins may receive an Office session. Configured
// ingest hosts and other shx.cz applications are deliberately not SSO targets.
const marketplaceAgenda = { origin: 'https://marketplaces.shx.cz', permissions: ['SuperAdmin'] } as const;
export const officeAgendas = {
  finance: { origin: 'https://finance.shx.cz', permissions: ['FinanceRead'] },
  attendance: { origin: 'https://dochazka.shx.cz', permissions: ['AttendanceSelf'] },
  marketing: { origin: 'https://marketing.shx.cz', permissions: ['MarketingRead'] },
  payroll: { origin: 'https://mzdy.shx.cz', permissions: ['PayrollSelf', 'PayrollRead', 'PayrollManage', 'PayrollApprove', 'PayrollPay'] },
  hr: { origin: 'https://personalistika.shx.cz', permissions: ['HrSelf', 'HrRead', 'HrManage'] },
  reports: { origin: 'https://personalistika.shx.cz', permissions: ['HrRead', 'HrManage'] },
  procurement: { origin: 'https://zakazky.shx.cz', permissions: ['SuperAdmin'] },
  wholesale: { origin: 'https://velkoobchod.shx.cz', permissions: ['SuperAdmin'] },
  marketplaces: marketplaceAgenda,
  pricing: marketplaceAgenda,
} as const;

export type OfficeModule = keyof typeof officeAgendas;

export function officeModuleDestination(module: OfficeModule): string {
  return officeAgendas[module].origin + (module === 'pricing' ? '/?module=pricing' : module === 'reports' ? '/?module=reports' : '/');
}

export function officeModuleForLocation(hostname: string, search: string): OfficeModule {
  const selected = new URLSearchParams(search).get('module');
  if (hostname === 'marketplaces.shx.cz' && selected === 'pricing') return 'pricing';
  if (hostname === 'personalistika.shx.cz' && selected === 'reports') return 'reports';
  for (const [module, agenda] of Object.entries(officeAgendas)) {
    if (hostname.startsWith(new URL(agenda.origin).hostname.split('.')[0] + '.')) return module as OfficeModule;
  }
  return selected && Object.hasOwn(officeAgendas, selected) ? selected as OfficeModule : 'finance';
}

export function officeAgendaForOrigin(origin: string) {
  return Object.values(officeAgendas).find(agenda => agenda.origin === origin);
}

export function officeDestination(value: string): URL {
  const url = new URL(value);
  if (url.username || url.password || !officeAgendaForOrigin(url.origin) || url.pathname !== '/') {
    throw new Error('Invalid Office destination');
  }
  return url;
}
